<template>
  <div class="myCollection">
    <div class="search">
      <div class="radio-group">
        <div v-for="item in menus" :key="item.id" class="custom-radio-card" :class="{ 'custom-radio-card-checked': templateType === item.id }" @click="changeTemplateType(item.id)">
          <div class="custom-radio-card-title">{{ item.name }}</div>
        </div>
      </div>
      <a-input-search
        class="search-input"
        enter-button
        v-model="keyword"
        @change="mockList"
        :placeholder="$t('project.inputSearchKeywords')"
        style="width: 300px"
      />
    </div>
    <div class="filter">
      <div class="filterLeft">
        <a-select
          v-model="comprehensiveValue"
          allowClear
          class="filterSelect"
          placeholder="综合"
          style="width: 150px"
        >
          <a-select-option v-for="(item, index) in comprehensiveOptions" :value="item.id" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select
          v-model="industryValue"
          allowClear
          class="filterSelect"
          placeholder="行业"
          style="width: 150px"
        >
          <a-select-option v-for="(item, index) in industryOptions" :value="item.value" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-range-picker
          class="filterSelect"
          format="YYYY-MM-DD"
          style="width: 270px; height: 32px"
          @change="onChange"
          @ok="onOk"
          @select="onSelect"
        />
      </div>
      <div class="filterRight">
        <div class="iconBox">
          <a-icon type="reload" class="icon" style="font-size: 20px" @click="refreshList()" />
          <a-icon type="appstore" class="icon" style="font-size: 20px" @click="changeList()" />
        </div>
      </div>
    </div>
    <div class="listTable project-kind-list">
      <CardList
        v-if="changeListFlag"
        :data-list="dataList"
        :pageTotal="pageTotal"
        :loadDataFunc="mockList"
        :preview-handle="previewHandle"
        cardType="collection"
        :directShowCencelCollect="directShowCencelCollect"
        class="cardList"
      />
      <div v-else class="listTable">
        <a-table
          :selectedRowKeys="selectedKeys"
          :bordered="false"
          :columns="columns"
          :dataSource="dataList"
          :pagination="pagination"
          :rowSelection="rowSelection"
          :rowKey="record => record.id"
        >
          <template slot="action" slot-scope="text, record">
            <a class="button-link" @click="previewHandle(record)">预览</a>
            <a-dropdown class="button-link" @click="handleDownSelect(record)" trigger="hover">
              <a class="ant-dropdown-link">
                下载<a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-for="item in record.versionList" :key="item">
                  V{{item}}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a class="button-link" @click="unfavoriteHandle(record)">取消收藏</a>
          </template>
          <template slot="coverUrl" slot-scope="text,record">
            <img :src="imgHost + record.coverUrl" alt="img" class="hover-mask"/>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal
      :visible="previewVisible"
      :footer="null"
      :title="$t('project.previewTemplate')"
      @cancel="handlePreviewCancel"
      :width="1550"
    >
      <PreviewTemplate v-if="previewVisible" :previewData="previewData" type='template'/>
    </a-modal>
  </div>
</template>

<script>

import { getCollegePage, cancelCollege } from '@/api/myTemplate'
import { downloadApi } from '@/api/myTemplate'
import CardList from './templateCard.vue'
import PreviewTemplate from './previewTemplate.vue'

export default {
  name: 'MyCollection',
  components: {
    CardList,
    PreviewTemplate
  },
  props: {
    
  },
  data() {
    return {
      templateType: '1',
      keyword: '',
      directShowCencelCollect: true,
      comprehensiveValue: undefined,
      comprehensiveOptions: [
        { id: 'publishTime', name: '最新发布' },
        { id: 'collectCnt', name: '热门推荐' },
        { id: 'downloadCnt', name: '最多使用' },
        { id: 'browseCnt', name: '最多浏览' }
      ],
      menus: [
        { id: '1', name: '项目方案' },
        { id: '2', name: '工艺模拟' }
      ],
      columns:[
        {
            title: '序号',
            width: 80,
            dataIndex: 'index'
          },
          {
            title: '模版名称',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '预览图',
            scopedSlots: { customRender: 'coverUrl' },
            width: 300,
            align: 'center',
          },
          {
            title: '版本',
            align: 'center',
            dataIndex: 'version'
          },
          {
            title: '状态',
            scopedSlots: { customRender: 'itemStatus' },
            align: 'center',
            dataIndex: 'itemStatus'
          },
          {
            title: '上传时间',
            dataIndex: 'publishTime',
            width: 300,
            align: 'center',
          },
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },
            width: 300,
            align: 'center',
          }
      ],
      statusValue: undefined,
      industryValue: undefined,
      industryOptions: [],
      timeRange: [],
      previewData: {},
      dataList: [],
      selectedKeys: [],
      previewVisible: false,
      changeListFlag: true,
      pagination: { pageSize: 5 },
      pageTotal: 0
    }
  },
  computed: {
    imgHost() {
      return process.env.VUE_APP_CTYUN_URL
    },
    rowSelection() {
      return {
        type: 'checkbox',
        showCheckedAll: true,
        onlyCurrent: false
      }
    }
  },
  watch: {
    templateType: {
      handler(newValue) {
        console.log(newValue, 'templateType')
        this.mockList()
      }
    },
    comprehensiveValue: {
      handler(newValue) {
        console.log(newValue, 'comprehensiveValue')
        this.mockList()
      }
    },
    industryValue: {
      handler(newValue) {
        this.mockList()
      }
    }
  },
  created() {
    this.industryOptions = JSON.parse(localStorage.getItem('getIndustryList') || '[]')
    this.mockList()
  },
  methods: {
    mockList(pageNo = 1, pageSize = 10) {
      const params = {
        keyword: this.keyword,
        itemStatus: this.statusValue,
        type: this.templateType,
        industry: this.industryValue,
        startPublishDate: this.timeRange.length ? this.timeRange[0] : '',
        endPublishDate: this.timeRange.length ? this.timeRange[1] : '',
        tempalteIds: [],
        sourceIds: [],
        valid: null,
        pageNo,
        pageSize,
        orderField: 'publishTime',
        orderType: 'desc'
      }
      getCollegePage(params).then(res => {
        if(res.status === 0) {
          this.dataList = res.data.data
          this.pageTotal = res.data.count
          this.dataList.forEach((item, index) => {
            item.index = index + 1
            item.itemStatus = Number(item.itemStatus) === 0 ? 'project.uploadSuccess' : 
                            Number(item.itemStatus) === 1 ? 'project.pendingReview' : 
                            Number(item.itemStatus) === 2 ? 'project.sold' : 
                            Number(item.itemStatus) === 3 ? 'project.reviewNotPassed' : 
                            Number(item.itemStatus) === -1 ? 'project.soldOff' : 'project.unknownStatus'
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onSelect(dateString, date) {
      console.log('onSelect', dateString, date)
    },
    onChange(dateString, date) {
      this.timeRange = dateString || []
      this.mockList()
    },
    onOk(dateString, date) {
      console.log('onOk: ', dateString, date)
    },
    refreshList() {
      this.statusValue = ''
      this.comprehensiveValue = ''
      this.industryValue = ''
      this.timeRange = []
      this.mockList()
    },
    changeList() {
      this.changeListFlag = !this.changeListFlag
    },
    previewHandle(item) {
      this.previewVisible = true
      this.previewData = item
    },
    handleDownSelect(data) {
      try {
        downloadApi({templateId: data.templateId, version: data.version}).then(res => {
          if(res.status === 0) {
            this.$message.success('下载成功')
          } else {
            this.$message.error(res.message)
          }
        })
      } catch (error) {
        console.log('下载失败', error)
      }
    },
    unfavoriteHandle(data) {
      const params = {
        templateId: data.templateId,
        version: data.version
      }
      cancelCollege(params).then(res => {
        if(res.status === 0) {
          this.$message.success('取消收藏成功')
          this.mockList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeTemplateType(id) {
      this.templateType = id
    },
    handlePreviewCancel(){
      this.previewVisible = false
    },
  }
}
</script>

<style lang="less" scoped>
.myCollection {
  display: flex;
  flex-direction: column;
  //padding:0  16px;
  .search,
  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    .radio-group {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .search-input {
      width: 300px;
    }
  }

  .filter {
    //height: 5%;
    //background-color: rgba(62, 86, 93, 0.3);
    .filterLeft,
    .filterRight {
      //width: 48%;
      //height: 100%;
      display: flex;
    }

    .filterLeft {
      display: flex;
      justify-content: space-between;
      align-items: center;
      //background: #00081c;
      padding: 5px;
      // width: 40%;

      .filterSelect {
        width: 120px;
        margin: 0 10px;
        &:first-of-type {
          margin-left: 0;
        }
      }
    }

    .filterRight {
      width: 25%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .iconBox {
        background: #00081c;
        padding: 5px;
      }

      .icon {
        margin: 0 5px;
        border: 1px solid #2b3347;
        cursor: pointer;
      }
    }
  }

  .listTable {
    margin-top: 10px;
    .hover-mask{
      width: auto;
      height: 36px;
      object-fit: cover;
      aspect-ratio: 4 / 3;
    }
    .button-link{
      margin-left: 15px;
      &::first-of-type{
        margin-left: 0;
      }
    }
    .cardList {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 10px 0;
      //overflow: auto;
    }
    .arco-dropdown-open .arco-icon-down {
      transform: rotate(180deg);
    }
    /* &-list {
       .more-card {
         width: 100%;
         margin-right: 10px;
         margin-left: 40px;
         background: var(--primary-bg-color);
         border: 1px solid var(--lv1-border-color);
         border-radius: 2px;
         cursor: pointer;
         display: flex;
         justify-content: center;
         align-items: center;

         .plus-icon {
           display: block;
           margin: 0 auto;
         }
       }
     }*/
  }
}
.custom-radio-card {
  background: #313132;
  width: 96px;
  height: 32px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #C0C0C0;
  cursor: pointer;
}

.custom-radio-card-title {
  color: #fff;
  font-size: 14px;
}

.custom-radio-card-checked {
  background-color: #0166FC;
}

.custom-radio-card:hover .custom-radio-card-title,
.custom-radio-card-checked .custom-radio-card-title {
  color: #fff;
}
</style>
